import {Component, OnInit, Input} from '@angular/core';
import {PaginationService} from '../pagination.service';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit {
    @Input() itemcount: number;
    @Input() itemsPerPage: number;
    currentPage;
    public pages = [];

    constructor(protected paginationService: PaginationService) {
    }

    ngOnInit() {
        this.itemsPerPage = this.paginationService.getItemsPerPage();
        this.setPageArray();
        this.paginationService.getSubject().subscribe((val) => {
            this.itemcount = val.itemCount;
            this.itemsPerPage = val.itemsPerPage;
            this.currentPage = val.currentPage;
            this.setPageArray();
        });
    }

    setPageArray() {
        this.pages = [];
        if (this.itemcount > this.itemsPerPage) {
            const pageCount = Math.ceil(this.itemcount / this.itemsPerPage);
            for (let a = 1; a <= pageCount; a++) {
                this.pages.push(a);
            }
        }
    }

    setPage(page) {
        this.paginationService.setCurrentPage(page);
    }

    setItemsPerPage(number) {
        console.log('setting items per page to:', number);
        this.paginationService.setCurrentPage(1);
        this.paginationService.setItemsPerPage(number);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/pagination/pagination.component.ts